// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2-4U0","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__39N6H"};